import { TYPE_META } from "./AgendaItem";

const ORDER = ["task", "deadline", "event", "call", "meeting", "payment_reminder", "followup"];

export default function AgendaLegend() {
  return (
    <div className="agenda-legend" data-testid="agenda-legend" aria-label="Legenda tipi">
      {ORDER.map((t) => {
        const m = TYPE_META[t];
        if (!m) return null;
        return (
          <span
            key={t}
            className="agenda-legend-item"
            style={{ "--_type-color": `var(${m.varName})` }}
            data-testid={`agenda-legend-${t}`}
          >
            <m.Icon size={11} aria-hidden />
            {m.label}
          </span>
        );
      })}
      <span
        className="agenda-legend-item"
        style={{ "--_type-color": "var(--pxos-type-overdue)" }}
        data-testid="agenda-legend-overdue"
      >
        <span style={{ fontWeight: 800 }}>!</span> Scaduto
      </span>
    </div>
  );
}
